import {createAsyncThunk} from '@reduxjs/toolkit';
import {CLDispatch, RootState} from 'common/src/redux/store';
import {setBrandPersonas} from '../brandPersonas.slice';
import brandGuidelinesApi from 'common/src/modules/brandGuidelines/brandGuidelines.api';
import {Persona} from 'common/src/modules/brandGuidelines/brandGuidelines.types';

export const addBrandPersona = createAsyncThunk<
  Persona[],
  Omit<Persona, 'id'>,
  {dispatch: CLDispatch; state: RootState}
>(
  'brandPersonas/add',
  async (personaData, {dispatch, rejectWithValue}) => {
    try {
      await brandGuidelinesApi.addPersona(personaData);
      
      // Reload personas from server to get updated list
      const personas = await brandGuidelinesApi.getPersonas();
      dispatch(setBrandPersonas(personas));
      
      return personas;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to add brand persona';

      return rejectWithValue(errorMessage);
    }
  },
); 